import {Col, Row} from "react-bootstrap";

export const ContactInfo = () => {
    return (
        <Row className="justify-content-center">
            <Col sm={12} lg={10}>
                <div id="contact" className="contact-info-bx slideInUp">
                    <Row className="align-items-md-center">
                        <Col lg={12} md={6} xl={5} className="text-center text-md-start">
                            <h5>Neem gerust contact op!</h5>
                        </Col>
                        <Col md={12} xl={7} className="text-center text-md-end">
                            <p className="mt-1">
                                <a className="text-black hover:text-primary" href="mailto:jennifer.coenraad@icloud.com">
                                    jennifer.coenraad@icloud.com
                                </a>
                            </p>
                            <p><span>Hogeschool Utrecht</span> <br></br> <a
                                href="https://share.google/ou35MIVosC1c0My46">Heidelberglaan 15 <br></br> 3584 CS
                                                                              Utrecht</a></p>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    );
};
